const C = require("../constants");

const openModalProductStockUpdate = modal => {
    return {
        type: C.PRODUCT_STOCK_UPDATE_MODAL,
        modal
    }
};

export {openModalProductStockUpdate};


// WEBPACK FOOTER //
// ./src/actions/ModalProductStockUpdateActions.js